import { useState } from 'react';
import { authApi } from '@/Api/authApi';

export function useForgotCredentials() {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const sendForgotCredentials = async (registration: string) => {
    setIsLoading(true);
    setError(null);

    try {
      // Appel API public via authApi
      const response = await authApi.sendForgotCredentials(registration);
      return response;
    } catch (err: any) {
      const errorMsg =
        err.response?.data?.message || 'Erreur lors de l\'envoi. Veuillez réessayer.';
      setError(errorMsg);
      throw new Error(errorMsg);
    } finally {
      setIsLoading(false);
    }
  };

  return { sendForgotCredentials, isLoading, error };
}
